import { ExternalDataService, PipelineDiagnostics } from '@repo/roche-xx-shared';
import { Breakpoints } from '@rocheglobal/roche-ui';
import React, { useEffect, useRef, useState } from 'react';

const getPipelineDiagnostics = async (): Promise<PipelineDiagnostics[]> => {
  const response = await ExternalDataService.getPipelineDiagnostics();
  return response.Items;
};

export const RochePipelineDiagnostics = (): JSX.Element => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState<PipelineDiagnostics[]>([]);
  const [hasMounted, setHasMounted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const getClientWidth = () => (typeof document !== 'undefined' ? document.body.clientWidth : null);
  const checkIsMobile = () => getClientWidth() < Breakpoints.LARGE;

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(checkIsMobile());

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!containerRef.current) {
        return;
      }

      try {
        const diagnosticsData = await getPipelineDiagnostics();
        setContent(diagnosticsData);
      } catch (error) {
        console.error('Error fetching pipeline diagnostics data:', error);
      }
    };

    fetchData();
  }, [hasMounted]);

  if (!hasMounted) {
    return null;
  }

  return (
    <div ref={containerRef}>
      <roche-pipeline-diagnostics content={JSON.stringify(content)} is-mobile={isMobile}></roche-pipeline-diagnostics>
    </div>
  );
};
